import { message, Modal } from "antd";
import { IAddCallback, api } from "./index";
import { lang } from "../context";
import { openPicker } from "../components/CategoriesPickerTree";
import { getSpaceIdByRootId, moveTips } from "../util";
import { folderTypeEnum } from "../config/permissions.config";
import { ActionFnEnum, FileType } from "../types";
import events from "../context/events";
import { getPageMenuLogId } from "../contextMenus/utils";
import { analysisLog } from "@/utils/logAnalytics";
const batchMove = (data: {
  batchMoveToDtoList: any[];
  from: any;
  to: any;
  isTeam: any;
  gname?: any;
  originId: any;
  reload?: Function;
  setData: Function;
  callback?: Function;
  onOK?: Function;
  onCancel?: Function;
  isDrag?: boolean;
}) => {
  const {
    batchMoveToDtoList,
    from,
    to,
    isTeam,
    gname,
    reload,
    setData,
    callback,
    originId,
    onCancel,
    isDrag,
    onOK
  } = data;
  const tip = moveTips(from, to, isTeam);
  Modal.confirm({
    // @ts-ignore
    content: lang(tip, { name: to.name }),
    title: lang("ctx.move.tips.title"),
    cancelText: lang("common.cancel"),
    okText: lang("common.confirm"),
    onCancel: () => {
      onCancel?.();
    },
    onOk: () => {
      if (!to.id) return;
      onOK?.();
      const useBatchMoveToDtoList = {
        batchMoveInfos: batchMoveToDtoList,
        toId: to.id,
        toType: to.type === 3 || gname ? 12 : to.type
      };
      const logId = getPageMenuLogId("doMove");
      console.log(
        logId,
        (from.spaceType || from.type)?.toString() || "",
        to.type?.toString() || "",
        batchMoveToDtoList.length?.toString(),
        isDrag ? "drag" : "click"
      );
      analysisLog(
        "xtbg_jzb_joyspace_home_1676548210761",
        logId,
        (from.spaceType || from.type)?.toString() || "",
        to.type?.toString() || "",
        batchMoveToDtoList.length?.toString(),
        isDrag ? "drag" : "click"
      );
      api.batch.moveTo(useBatchMoveToDtoList as any).then((data1) => {
        console.log(data1, "moveTo1111111");
        if (data1?.data) {
          reload?.();
          if (!batchMoveToDtoList.length) {
            return;
          }
          const ids = batchMoveToDtoList.map((item: any) => item.targetId);
          let pageIds: any[] = [];
          let folderIds: any[] = [];
          for (let item of batchMoveToDtoList) {
            if (item.targetType === FileType.Folder) {
              folderIds.push(item.targetId);
              continue;
            } else {
              pageIds.push(item.targetId);
            }
          }
          message.success(data1?.data || lang("common.success"));
          events.emit("list.check");
          // 判断是否移动到当前位置
          const res = getSpaceIdByRootId(originId, to.id);

          if (!res) {
            setData({
              type: ActionFnEnum.BATCHREMOVE,
              pids: pageIds,
              cids: folderIds
            } as any);
            from.type !== folderTypeEnum.GROUP &&
              events.emit("batchDeleteFolderById", folderIds, to.id);
          }
        } else {
          message.error(data1?.status || lang("common.fail"));
        }
        callback?.();
      });
    }
  });
};
const Move: IAddCallback = (props, isAllow, isTeam?: boolean) => {
  const {
    data: propsData,
    reload,
    freshLeftTreeByFolderById,
    gname,
    gid,
    setData,
    originId = ""
  } = props;
  let folderArr = [...propsData];
  const defaultNav = gname
    ? [
        {
          name: gname,
          id: gid,
          icon: "iconapp_btn_folder",
          level: 1,
          isLeaf: false,
          type: 3,
          disabled: false,
          selectable: true
        }
      ]
    : null;
  const selectArray: {
    id: string;
    rootId: string;
    type: string;
  }[] = [];
  const batchMoveToDtoList = folderArr.map((item) => {
    selectArray.push({
      id: item.id,
      rootId: item.space_id,
      type: typeof item.page_type !== "undefined" ? "file" : "folder"
    });
    return {
      fromType: isTeam ? folderTypeEnum.SHARE : gname ? folderTypeEnum.SHARE : folderTypeEnum.MY,
      targetId: item.id,
      targetType: typeof item.page_type !== "undefined" ? 1 : 4
    };
  });
  return [
    {
      children: lang("ctx.move.title"),
      callbackOrModal: () => {
        openPicker({
          reload,
          originId,
          defaultNav,
          title: `${selectArray.length || 1}个对象`,
          isTeam: isTeam,
          isGroupSpace: gname ? true : false,
          callback: (data, close) => {
            batchMove({
              from: folderArr[0],
              to: data,
              isTeam,
              originId,
              batchMoveToDtoList,
              reload,
              setData,
              gname,
              callback: () => {
                close();
              }
            });
          },
          selectArray: selectArray as any,
          treeFreshFunction: (data: any) => {
            freshLeftTreeByFolderById?.(data);
          }
        });
      },
      isAllow,
      type: "move"
    }
  ];
};
export default Move;
export { batchMove };
